import React from 'react';
import classNames from 'classnames';
import {useClpPurchaseContext} from '../../context/clp-purchase-context.react-component';
import styles from './course-sidebar-container.module.scss';
import {BuyBox} from '../buy-box/buy-box.react-component';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {EnrollmentBox} from '@/features/course-landing-page/components/enrollment-box';
import {EnrolledBox} from '@/features/course-landing-page/components/enrolled-box';
import {GrowWithGoogleEnrollmentBox} from '@/features/course-landing-page/components/grow-with-google-enrollment-box';
import {CourseContentPlacement} from '@/features/course-landing-page/course-landing-page.react-component';

interface CourseSidebarNoTabsContainerProps {
    placement: CourseContentPlacement;
}

/**
 * CourseSidebarNoTabsContainer component - this renders for enrolled, free, non-Personal Plan paid courses, and Grow with Google subscription courses
 */
export function CourseSidebarNoTabsContainer({placement}: CourseSidebarNoTabsContainerProps) {
    const course = useClpCourse();
    const {
        isCourseIncludedInUserSubscription,
        isCourseIncludedInGrowWithGoogleSubscription,
        isEnrolledInCourse,
    } = useClpPurchaseContext();

    return (
        <div
            className={classNames(styles.container, {
                [styles['sidebar-container']]: placement === CourseContentPlacement.SIDEBAR,
            })}
        >
            {isCourseIncludedInGrowWithGoogleSubscription && !isCourseIncludedInUserSubscription ? (
                <GrowWithGoogleEnrollmentBox placement={placement} />
            ) : isCourseIncludedInUserSubscription || (course.isFree && !isEnrolledInCourse) ? (
                <EnrollmentBox placement={placement} />
            ) : isEnrolledInCourse ? (
                <EnrolledBox placement={placement} />
            ) : (
                <BuyBox placement={placement} />
            )}
        </div>
    );
}
